import { render, staticRenderFns } from "./workbenchEnterpriseDetails.vue?vue&type=template&id=25aa554c&scoped=true&"
import script from "./workbenchEnterpriseDetails.vue?vue&type=script&lang=js&"
export * from "./workbenchEnterpriseDetails.vue?vue&type=script&lang=js&"
import style0 from "./workbenchEnterpriseDetails.vue?vue&type=style&index=0&id=25aa554c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aa554c",
  null
  
)

export default component.exports